import {inject, observer} from 'mobx-react';
import React from 'react';
import {ThemeContext} from '../../apiContexts';
import Routers from '../../routes';
import ModalContainer from '../modal-container';
import CompanyProvider from '../../providers/company';
import QueryProvider from 'src/autobahn/providers/QueryProvider';

const AppContainer = ({theme, ...props}) => {
    return (
        <QueryProvider>
            <CompanyProvider>
                <ThemeContext.Provider value={theme}>
                    <ModalContainer>
                            <Routers {...props} />
                    </ModalContainer>
                </ThemeContext.Provider>
            </CompanyProvider>
        </QueryProvider>
    );
};

const mapping = ({store}) => ({
    theme: store.theme,
});

export default inject(mapping)(observer(AppContainer));
